<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card tab2-card">
                    <div class="card-body tab2-card">
                        <form [formGroup]="supplierDetailsForm" class="needs-validation" novalidate>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <h4>{{pjIdentificationData}}</h4>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <label>{{name}}</label>
                                    <input class="form-control" type="text" formControlName="name" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{legalForm}}</label>
                                    <input class="form-control" type="text" formControlName="legalForm" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{cui}}</label>
                                    <input class="form-control" type="text" formControlName="cui" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{onrcRegistrationNumber}}</label>
                                    <input class="form-control" type="text" formControlName="onrcRegistrationNumber" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <label>{{phone}}</label>
                                    <input class="form-control" type="text" formControlName="phone" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{mobile}}</label>
                                    <input class="form-control" type="text" formControlName="mobile" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{fax}}</label>
                                    <input class="form-control" type="text" formControlName="fax" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{email}}</label>
                                    <input class="form-control" type="text" formControlName="email" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <h4>{{registeredOfficeAddress}}</h4>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-sm-3 mb-0">
                                    <label>{{county}}<span>*</span></label>
                                    <select class="form-control digits" formControlName="county">
                                        <option *ngFor="let county of counties" [value]="county.id">
                                            {{ county.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-xl-3 col-sm-3 mb-0">
                                    <label>{{city}}<span>*</span></label>
                                    <select class="form-control digits" formControlName="city">
                                        <option *ngFor="let city of cities" [value]="city.id">
                                            {{ city.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <label>{{streetName}}<span>*</span></label>
                                    <input class="form-control" type="text" formControlName="streetName" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{streetNumber}}<span>*</span></label>
                                    <input class="form-control" type="text" formControlName="streetNumber" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{block}}</label>
                                    <input class="form-control" type="text" formControlName="block" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{floor}}</label>
                                    <input class="form-control" type="text" formControlName="floor" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <label>{{apartment}}</label>
                                    <input class="form-control" type="text" formControlName="apartment" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{postalCode}}<span>*</span></label>
                                    <input class="form-control" type="text" formControlName="postalCode" required />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <h4>{{mailingAddress}}</h4>
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label class="d-block" for="chk-ani">
                                        <input class="checkbox_animated" id="chk-ani" type="checkbox" disabled
                                            checked="isSameAddress">
                                        {{sameAddress}}
                                    </label>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-sm-3 mb-0">
                                    <label>{{county}}<span>*</span></label>
                                    <select class="form-control digits" formControlName="correspondenceCounty">
                                        <option *ngFor="let county of counties" [value]="county.id">
                                            {{ county.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-xl-3 col-sm-3 mb-0">
                                    <label>{{city}}<span>*</span></label>
                                    <select class="form-control digits" formControlName="correspondenceCity">
                                        <option *ngFor="let city of cities" [value]="city.id">
                                            {{ city.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <label>{{streetName}}<span>*</span></label>
                                    <input class="form-control" type="text"
                                        formControlName="correspondenceStreetName" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{streetNumber}}<span>*</span></label>
                                    <input class="form-control" type="text"
                                        formControlName="correspondenceStreetNumber" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{block}}</label>
                                    <input class="form-control" type="text" formControlName="correspondenceBlock" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{floor}}</label>
                                    <input class="form-control" type="text" formControlName="correspondenceFloor" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <label>{{apartment}}</label>
                                    <input class="form-control" type="text" formControlName="correspondenceApartment" />
                                </div>
                                <div class="col-xl-3 col-md-3">
                                    <label>{{postalCode}}<span>*</span></label>
                                    <input class="form-control" type="text" formControlName="correspondencePostalCode"
                                        required />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-xl-3 col-md-3">
                                    <h4>{{providerUsers}}</h4>
                                </div>
                            </div>
                            <div class="category-table custom-datatable">
                                <div class="table-responsive">
                                    <ng2-smart-table [settings]="providerUsersSettings" [source]="userList">
                                    </ng2-smart-table>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>